<template>

  <div class="rolectrl">
    <Card :bordered="false">
      <div slot="title">
        <div class="des-cardTittle-box">
          <div class="leftFlex">
            <Divider orientation="left">{{ langMap.roleManagement[lang] }}</Divider>
          </div>
          <div class="rightFLex">
            <Button
              type="primary"
              @click="addRoleFunc"
            >{{ langMap.addRole[lang] }}</Button>
          </div>
        </div>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="roleListColumns"
        :data="roleListData"
      ></Table>
    </Card>

    <!--modal区域-->
    <Modal
      :title="langMap.addRole[lang]"
      v-model="addRole"
      :mask-closable="false"
    >
      <Form
        ref="roleForm"
        :model="addroleModel"
        :rules="addroleRules"
        :label-width="80"
      >
        <FormItem
          :label="langMap.roleName[lang]"
          prop="roleName"
        >
          <Input
            v-model="addroleModel.roleName"
            :placeholder="langMap.roleName[lang]"
          ></Input>
        </FormItem>
        <FormItem
          :label="langMap.roleCode[lang]"
          prop="roleCode"
        >
          <Input
            v-model="addroleModel.roleCode"
            :placeholder="langMap.roleCode[lang]"
          ></Input>
        </FormItem>

        <FormItem
          :label="langMap.remarks[lang]"
          prop="roleRemark"
        >
          <Input
            v-model="addroleModel.roleRemark"
            type="textarea"
            :autosize="{minRows: 2,maxRows: 5}"
            :placeholder="langMap.remarks[lang]"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cencleAddRole">{{ langMap.cancel[lang] }}</Button>
        <Button
          type="primary"
          @click="sureAddRole"
        >{{ langMap.submit[lang] }}</Button>
      </div>
    </Modal>
    <!-- 角色赋值菜单 -->
    <Modal
      :mask-closable="false"
      v-model="userToMenu"
      :title="langMap.roleAssignMenu[lang]"
    >
      <Tree
        ref="menuTree"
        :data="menuList"
        show-checkbox
      ></Tree>
      <div slot="footer">
        <Button @click="userToMenu=false;">{{ langMap.cancel[lang] }}</Button>
        <Button
          type="primary"
          @click="postUserMenu"
        >{{ langMap.submit[lang] }}</Button>
      </div>
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="resourcesToRole"
      :title="langMap.roleAssignResources[lang]"
      width="820"
    >
      <Table
        :loading="tableLoading2"
        border
        :columns="resourcesCol"
        :data="resourcesList"
        @on-selection-change="selectHandler"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="resourcesList.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
      <div slot="footer">
        <Button @click="resourcesToRole=false">{{ langMap.cancel[lang] }}</Button>
        <Button
          type="primary"
          @click="postResourcesMenu"
        >{{ langMap.submit[lang] }}</Button>
      </div>
    </Modal>
  </div>

</template>

<script>
//引入api
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  name: "rolectrl",
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 260 + "px",
      tableLoading2: true,
      index: 1,
      total: 0,
      //table加载
      tableLoading: true,
      roleListData: [], //角色数据
      //添加角色
      addRole: false,
      //添加角色数据
      addroleModel: {
        roleName: "",
        roleCode: "",
        roleRemark: ""
      },
      //角色赋值菜单
      userToMenu: false,
      menuList: [],
      resourcesToRole: false,
      resourcesList: [],
      checkedResourcesList: [],
      staticRoleId: ""
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    resourcesCol() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: langMap.name[this.lang],
          key: "name"
        },
        {
          title: langMap.route[this.lang],
          key: "url"
        },
        {
          title: langMap.method[this.lang],
          key: "method"
        }
      ]
    },
    roleListColumns() {
      return [
        {
          title: langMap.roleName[this.lang],
          minWidth: 120,
          key: "roleName"
        },
        {
          title: langMap.roleCode[this.lang],
          minWidth: 120,
          key: "roleCode"
        },
        {
          title: langMap.createTime[this.lang],
          minWidth: 150,
          key: "createTime"
        },
        {
          title: langMap.updateTime[this.lang],
          minWidth: 150,
          key: "updateTime"
        },
        {
          title: langMap.status[this.lang],
          minWidth: 120,
          key: "roleState",
          render: (h, params) => {
            if (params.row.roleState == 1) {
              return h("span", langMap.normal[this.lang]);
            } else {
              return h("span", langMap.abnormal[this.lang]);
            }
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 350,
          align: "center",
          render: (h, params) => {
            //禁用启用判断
            let rendText = langMap.enable[this.lang];
            if (params.row.roleState == 1) {
              rendText = langMap.disable[this.lang];
            }
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      //赋值角色caid
                      this.getMenuList(params.row.roleId);
                    }
                  }
                },
                langMap.assignMenu[this.lang]
              ),
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              }),
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.whether[this.lang] + rendText + langMap.role[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "system-server/sys/updateRoleState?roleId=" +
                                params.row.roleId,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getRoleList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                rendText
              ),
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              }),
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.roleDeleteConfirmation[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "system-server/sys/removeRole?roleId=" +
                                params.row.roleId,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getRoleList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            ]);
          }
        }
      ]
    },
    addroleRules() {
      return {
        roleName: [
          { required: true, message: langMap.pleaseEnterRoleName[this.lang], trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: langMap.roleNameFormatError[this.lang],
            trigger: "blur"
          }
        ],
        roleCode: [
          { required: true, message: langMap.pleaseEnterRoleCode[this.lang], trigger: "blur" },
          {
            pattern: /([^\s])/g,
            message: langMap.roleCodeFormatError[this.lang],
            trigger: "blur"
          }
        ],
        roleRemark: [
          { pattern: /([^\s])/g, message: langMap.remarkFormatError[this.lang], trigger: "blur" }
        ]
      }
    }
  },
  created() {
    this.getRoleList();
  },
  methods: {
    //打开添加模态框
    addRoleFunc() {
      this.addRole = true;
    },
    //取消添加
    cencleAddRole() {
      for (var i in this.addroleModel) {
        this.addroleModel[i] = "";
      }
      this.addRole = false;
    },
    //保存角色
    sureAddRole() {
      this.$refs.roleForm.validate(valid => {
        if (valid) {
          this.$Spin.show();
          api
            .postData("system-server/sys/saveRole", this.addroleModel, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.tip[this.lang],
                  desc: langMap.operationSuccess[this.lang]
                });
                this.getRoleList();
                this.addRole = false;
              }
              this.$Spin.hide();
            });
        }
      });
    },
    //获取角色
    getRoleList() {
      this.tableLoading = true;
      api.getData("system-server/sys/getRoleList", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.roleListData = res.data;
        }
        this.tableLoading = false;
      });
    },

    //获取可以赋值到角色的菜单
    getMenuList(roleId) {
      //存储roleid
      this.staticRoleId = roleId;
      this.menuList = [];
      api
        .getData("system-server/sys/getRoleMenu?roleId=" + roleId, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            //处理数据
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].children.length > 0) {
                for (var j = 0; j < res.data[i].children.length; j++) {
                  if (res.data[i].children[j].checked > 0) {
                    res.data[i].children[j].checked = true;
                  } else {
                    res.data[i].children[j].checked = false;
                  }
                }
                res.data[i].checked = false;
              } else {
                if (res.data[i].checked > 0) {
                  res.data[i].checked = true;
                } else {
                  res.data[i].checked = false;
                }
              }
            }
            this.menuList = res.data;
            this.userToMenu = true;
          }
        });
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getResourcesList(this.staticRoleId);
    },
    getResourcesList(roleId) {
      this.tableLoading2 = true;
      //存储roleid
      this.staticRoleId = roleId;
      api
        .getData(
          "system-server/sys/role/resources/list?roleId=" +
            roleId +
            "&index=" +
            this.index,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            //处理数据
            let rows = res.data.rows;
            for (var i = 0; i < rows.length; i++) {
              rows[i]._checked = rows[i].checked;
              if (rows[i].checked) {
                this.checkedResourcesList.push(rows[i].id);
              }
            }
            this.resourcesList = rows;
            this.total = res.data.total;
            this.resourcesToRole = true;
          }
          this.tableLoading2 = false;
        });
    },

    postResourcesMenu() {
      let data = {
        roleId: this.staticRoleId,
        resIds: this.checkedResourcesList
      };
      this.$Spin.show();
      api
        .postData("system-server/sys/resourcesToRoleData", data, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: langMap.promptFromSystem[this.lang],
              desc: langmap.operationSuccess[this.lang]
            });
          }
          this.resourcesToRole = false;
          this.$Spin.hide();
        });
    },
    selectHandler(selection) {
      //console.log(selection);
      for (var i = 0; i < selection.length; i++) {
        this.checkedResourcesList.push(selection[i].id);
      }
    },
    /**
     *提交角色菜单赋值
     */
    postUserMenu() {
      var postArray = [];
      var allSelect = this.$refs.menuTree.getCheckedNodes();
      //获取到checkbox对的
      for (var i = 0; i < allSelect.length; i++) {
        var basicData = allSelect[i];
        if (basicData.children.length == 0 && basicData.parentId > 0) {
          //获取选中id
          var childMenuId = basicData.menuId;
          var childJson = {
            menuId: childMenuId,
            roleId: this.staticRoleId
          };
          postArray.push(childJson);

          var parMenuId = basicData.parentId;
          var parJson = {
            menuId: parMenuId,
            roleId: this.staticRoleId
          };
          postArray.push(parJson);
        } else {
          //获取选中id
          var childMenuId = basicData.menuId;
          var childJson = {
            menuId: childMenuId,
            roleId: this.staticRoleId
          };
          postArray.push(childJson);
        }
      }
      //提交去重
      var clearPost = this.clearData(postArray);
      //解决角色赋值菜单不能为空的清空
      var newJson = {
        roleId: this.staticRoleId,
        list: clearPost
      };
      //提交菜单数据
      this.$Spin.show();
      api.postData("system-server/sys/menuToRole", newJson, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.promptFromSystem[this.lang],
            desc: res.msg
          });
        } else {
          this.$Notice.success({
            title: langMap.promptFromSystem[this.lang],
            desc: langMap.operationSuccess[this.lang]
          });
        }
        this.userToMenu = false;
        this.$Spin.hide();
      });
    },
    //数组去重
    clearData(arrObj) {
      var arr = arrObj,
        result = [],
        i,
        j,
        len = arr.length;
      for (i = 0; i < len; i++) {
        for (j = i + 1; j < len; j++) {
          if (arr[i].menuId === arr[j].menuId) {
            j = ++i;
          }
        }
        result.push(arr[i]);
      }
      return result;
    }
  }
};
</script>

<style>
</style>
